import { clsx } from 'clsx';

import { TIconSize, sizes } from '@treezor/design-system';

import { defaultSvgs, lightSvgs } from '@/assets/svg/index';

import { TBrandingIconName, TBrandingMode } from './BrandingIcon.types';

export type TBrandingIconProps = {
  name: TBrandingIconName;
  size?: TIconSize;
  mode?: TBrandingMode;
  className?: string;
};

const iconSizes: Record<(typeof sizes)[number], string> = {
  xxs: 'w-[12px]',
  xs: 'w-[16px]',
  s: 'w-[20px]',
  m: 'w-[24px]',
  l: 'w-[32px]',
  xl: 'w-[48px]',
  xxl: 'w-[80px]',
};

export const BrandingIcon = ({ name, mode = 'default', size = 'm', className, ...props }: TBrandingIconProps) => {
  const imgClassName = clsx(iconSizes[size], className);
  const imgSrc = mode === 'light' ? lightSvgs[name] : defaultSvgs[name];

  return <img className={imgClassName} src={imgSrc} {...props} />;
};
